export enum FontWeight {
  Thin = 300,
  Default = 500,
  SemiBold = 600,
  Bold = 800,
  Black = 900,
}
